<template>
    <div class="routes-content mt-3">
        <nav>
            <ul class="tabs-header">
                <li class="control-tab back">
                    <a @click="load('prev')">
                        <span><i class="bi bi-caret-left-fill"></i></span>
                    </a>
                </li>
                <li v-for="(value, name, index) in weekData" :class="[selectedDate === name ? 'active-tab' : 'inactive-tab']">
                    <template v-if="showBadge && value.badge">
                        <div class="non-stop-badge">NON-STOP</div>
                    </template>
                    <a :href="`/s/${from}-${to}?date=${formatDateForQuery(name)}`" @click.prevent="handleClick(name ,value)" :class="[value.no_flights ? 'no-flights' : '']">
                        <span class="d-block tab-date">{{ getFormattedDate(name) }}</span>
                        <span class="d-block tab-duration" v-if="value.no_flights">No flights</span>
                        <span class="d-block tab-duration" v-else>{{ convertMinutesToTime(value.duration) }}</span>
                    </a>
                </li>
                <li class="control-tab forward">
                    <a @click="load('next')">
                        <span><i class="bi bi-caret-right-fill"></i></span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

import { parse, format } from 'date-fns'
import axios from "axios";
export default {
    name: "DateSelector",
    props: {
        dataJson: {
            required: true,
        },
        selectedDate: {
            required: true,
        },
        from: {
            required: true,
        },
        to: {
            required: true,
        }
    },
    computed: {
        showBadge() {
            let flag = false;
            Object.keys(this.weekData).forEach((key) => {
                if (!this.weekData[key].badge) {
                    flag = true;
                }
            });
            return flag;
        }
    },
    data() {
        return {
            weekData: [],
            paginationDate: null
        }
    },
    mounted() {
        this.weekData = JSON.parse(this.dataJson);
        this.paginationDate = this.selectedDate
    },
    methods: {
        getFormattedDate(date) {
            return format(parse(date, 'yyyyMMdd', new Date()), 'EEE dd MMM');
        },
        formatDateForQuery(date) {
            return format(parse(date, 'yyyyMMdd', new Date()), 'Y-MM-dd');
        },
        convertMinutesToTime(minutes, separator = '') {
            const hours = Math.floor(minutes / 60);
            let remainingMinutes = minutes % 60;
            if (remainingMinutes < 10) {
                remainingMinutes = '0'+remainingMinutes;
            }
            return hours + "h" + separator + remainingMinutes + "m";
        },
        handleClick(name, value) {
            if (!value.no_flights) {
                window.location.href = `/s/${this.from}-${this.to}?date=${this.formatDateForQuery(name)}`;
            }
        },
        load(type) {
            axios.get(`/api/week/${type}/${this.from}/${this.to}?date=${this.formatDateForQuery(this.paginationDate)}`).then((res) => {
                this.weekData = res.data.data;
                this.paginationDate = res.data.date;
            })
        }
    }

}
</script>

<style scoped>

</style>
